import { css } from 'lit';

export const style = css`
  fs-body-text {
    margin-bottom: 1em;
    text-align: left;
  }

  /* stylelint-disable-next-line selector-id-pattern */
  #employmentModal {
    margin-bottom: 0.5em;
  }
`;
